import { useEffect } from 'react';
import { ApplyApp } from './apply/ApplyApp';
import { AdminApp } from './admin/AdminApp';
import type { SessionResponse } from './api/types';

// Top-level switch: the applicant flow lives under /apply and the staff admin
// console under /admin (each its own router with a basename). The public root
// belongs to the applicant experience; unknown frontend paths land there too.
function App({ magicSession }: { magicSession: Promise<SessionResponse> | null }) {
  const path = window.location.pathname;
  if (path.startsWith('/apply')) return <ApplyApp magicSession={magicSession} />;
  if (path.startsWith('/admin')) return <AdminApp />;
  return <RedirectToApply />;
}

function RedirectToApply() {
  useEffect(() => {
    window.location.replace('/apply');
  }, []);
  return null;
}

export default App;
